import { render, staticRenderFns } from "./VAdministrationActionbar.vue?vue&type=template&id=ceb7f944&"
import script from "./VAdministrationActionbar.vue?vue&type=script&lang=ts&"
export * from "./VAdministrationActionbar.vue?vue&type=script&lang=ts&"
import style0 from "./VAdministrationActionbar.vue?vue&type=style&index=0&id=ceb7f944&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports